import React from 'react'
import { useParams } from 'react-router'
// Component
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { PlayerContext } from 'components/Player/__Players.context'

const Player: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.PlayerParams>()

  return (
    <PlayerContext.Provider value={{ params: params }}>
      {p.phase === 'detail' && <Detail />}
    </PlayerContext.Provider>
  )
}

export default Player
